"use strict";

exports.__esModule = true;
var BaseUrls = {
  accountManagement: process.env.REACT_APP_ACCOUNT_URL + "/api",
  schedule: process.env.REACT_APP_SCHEDULE_URL + "/api",
  patients: process.env.REACT_APP_PATIENTS_URL + "/api",
  appointments: process.env.REACT_APP_APPOINTMENTS_URL + "/api",
  lookUps: process.env.REACT_APP_LOOK_UPS_URL + "/api",
  static: process.env.REACT_APP_STATIC_URL + "/api",
  payment: process.env.REACT_APP_PAYMENT_URL + "/api",
  vezeetaNative: process.env.REACT_APP_VEZEETA_NATIVE_URL + "/api",
  salesForce: process.env.REACT_APP_SALES_FORCE_URL + "/api",
  profile: process.env.REACT_APP_PROFILE_URL + "/graphql"
};

var Urls = {
  getCountries: BaseUrls.lookUps + "/Countries",
  getCountryList: BaseUrls.lookUps + "/CountryCodes",
  getCountryCodes: BaseUrls.lookUps + "/CountryCodes",
  getCultures: BaseUrls.lookUps + "/Cultures",
  getCities: BaseUrls.lookUps + "/Cities",
  getAreas: BaseUrls.lookUps + "/Areas",
  getSpecialities: BaseUrls.lookUps + "/Specialities",

  getPrefixTitles: BaseUrls.static + "/PrefixTitle/GetPrefixTitlesByCountryId?",
  currencyConversion: BaseUrls.static + "/Currency/GetCurrencyConversions",
  getInsuranceProvidersByCountryId: BaseUrls.static + "/Insurance/GetInsuranceProvidersByCountryId?countryId=",
  getProfessionalTitles: BaseUrls.static + "/DoctorTitle/GetDoctorTitlesByCountryId?",

  getPatientAppointmentsUrl: BaseUrls.schedule + "api/Schedule/GetPatientReservations",
  getReservationDetailsUrl: BaseUrls.schedule + "api/Schedule/GetReservationDetails",
  getConfirmationsUrl: BaseUrls.schedule + "/Confirmations/GetWeeksConfirmations",
  saveConfirmationsUrl: BaseUrls.schedule + "/Confirmations/SetConfirmations",
  getWorkingHours: BaseUrls.schedule + "/WorkingHours/GetWorkingHours",
  saveWorkingHours: BaseUrls.schedule + "/WorkingHours/SaveWorkingHours",
  getScheduleTypes: BaseUrls.schedule + "/Schedule/getScheduleTypes",
  setScheduleTypes: BaseUrls.schedule + "/Schedule/setScheduleTypes",
  getAllowReservationWindow: BaseUrls.schedule + "/Schedule/getAllowReservationWindow",
  setAllowReservationWindow: BaseUrls.schedule + "/Schedule/setAllowReservationWindow",
  getVacations: BaseUrls.schedule + "/Vacation/GetVacations",
  setVacations: BaseUrls.schedule + "/Vacation/SetVacations",
  getRamadanSchedule: BaseUrls.schedule + "/Schedule/GetRamdanSchedule",

  getPatientRelativeTypes: BaseUrls.patients + "/Patients/GetPatientRelativeTypes",
  getPatientByKeyUrl: BaseUrls.patients + "/Patients/GetPatientsByPatientKeys",
  searchPatientsByKeyword: BaseUrls.patients + "/Patients/GetPatientsList",
  createPatient: BaseUrls.patients + "/Patients/AddPatients",
  editPatient: BaseUrls.patients + "/Patients/EditPatient",
  deletePatientByKeyUrl: BaseUrls.patients + "/Patients/DeletePatients",

  fetchAppointmentsUrl: BaseUrls.appointments + "/Reservation/GetReservationDetails",
  createAppointmentUrl: BaseUrls.appointments + "/Reservation/UpsertReservations",
  markAppointmentAsNoShow: BaseUrls.appointments + "/Reservation/MarkReservationsAsNoShow",
  undoAppointmentNoShow: BaseUrls.appointments + "/Reservation/UndoNoShowReservations",
  checkInAppointment: BaseUrls.appointments + "/Reservation/UpdateReservationsStatus",
  cancelAppointment: BaseUrls.appointments + "/Reservation/CancelReservations",
  countReservationsInRange: BaseUrls.appointments + "/Reservation/CountReservationsInRange",

  getAllSpecialities: BaseUrls.vezeetaNative + "/Specialities/GetMainSpecialities",
  getMainSpecialities: BaseUrls.vezeetaNative + "/Specialities/GetMainSpecialities",
  getSubSpecialities: BaseUrls.vezeetaNative + "/Specialities/GetSubSpecialities",

  validateToken: BaseUrls.accountManagement + "/Account/ValidateToken",
  reGenerateToken: BaseUrls.accountManagement + "/Account/ReGenerateToken",
  getAccountByKey: BaseUrls.accountManagement + "/Account/GetAccountByKey?accountKey=",
  getAccountsByKeys: BaseUrls.accountManagement + "/Account/GetAccountsByKeys",
  getAccountStructure: BaseUrls.accountManagement + "/Account/GetAccountStructure",
  signOut: BaseUrls.accountManagement + "/Account/SignOut",

  sso: {
    generateToken: BaseUrls.accountManagement + "/Account/GenerateToken",
    validateToken: BaseUrls.accountManagement + "/Account/ValidateToken"
  },

  account: {
    getAccountByKey: BaseUrls.accountManagement + "/Account/GetAccountByKey?accountKey=",
    registerAccount: BaseUrls.accountManagement + "/Account/RegisterAccount",
    saveProfilePhoto: BaseUrls.accountManagement + "/Account/SaveProfilePhoto",
    signIn: BaseUrls.accountManagement + "/Account/SignIn",
    socialSignIn: BaseUrls.accountManagement + "/Account/SocialSignIn",
    editAccount: BaseUrls.accountManagement + "/Account/EditBasicInfo",
    getAccount: BaseUrls.accountManagement + "/Account/GetBasicInfo",
    sendForgetPasswordMessage: BaseUrls.accountManagement + "/Messaging/SendForgetPasswordMessage",
    updatePassword: BaseUrls.accountManagement + "/Account/UpdatePassword"
  },

  entity: {
    addEntityImage: BaseUrls.accountManagement + "/Entity/AddEntityImage",
    createEntity: BaseUrls.accountManagement + "/Entity/UpsertEntity",
    getEntity: BaseUrls.accountManagement + "/Entity/GetClinic"
  },

  payment: {
    getPaymentTypes: BaseUrls.payment + "/PaymentMethod/GetPaymentTypesAndMethods?",
    getPaymentCycles: BaseUrls.accountManagement + "/Payment/GetPaymentCycles?productLineId=",
    getAccountPaymentDetails: BaseUrls.payment + "/Account/GetAccountPaymentDetails?accountkey=",
    getAccountCards: BaseUrls.payment + "/Account/GetAccountCardsByAccountKey",
    setPaymentDetails: BaseUrls.payment + "/Account/SetAccountPaymentTypeAndMethod",
    getCountryPaymentAttributes: BaseUrls.accountManagement + "/Payment/GetCountryPaymentAttributes",
    addAccountCardAndGetMerchantPageInfo: BaseUrls.payment + "/Payfort/AddAccountCardAndGetMerchantPageInfo",
    updateAndChargeAccountCard: BaseUrls.payment + "/Payfort/UpdateAndChargeAccountCard?",
    submitAccountChargeResponse: BaseUrls.payment + "/Payfort/SubmitChargeAccountCardResponse?",
    addTransaction: BaseUrls.payment + "/Transaction/AddTransaction",
    setPaymentMethod: BaseUrls.accountManagement + "/Payment/SetPaymentMethod"
  },

  verification: {
    verifyPhone: BaseUrls.accountManagement + "/Verification/VerifyPhone",
    sendPhoneVerificatoinCode: BaseUrls.accountManagement + "/Verification/SendPhoneVerificatoinCode"
  },

  productLines: {
    getProductLines: BaseUrls.accountManagement + "/ProductLine/GetProductLines",
    getRegisteredProductLines: BaseUrls.accountManagement + "/ProductLine/GetRegisteredProductLines",
    customizeBook: BaseUrls.accountManagement + "/ProductLine/CustomizeBook",
    customizeCare: BaseUrls.accountManagement + "/ProductLine/CustomizeCare",
    getSpecialityGroups: BaseUrls.accountManagement + " /Speciality/GetSpecialityGroups",
    getCustomizeCare: BaseUrls.accountManagement + "/ProductLine/GetCustomizeCare",
    getCustomizeBook: BaseUrls.accountManagement + "/ProductLine/GetCustomizeBook",
    deleteBook: BaseUrls.accountManagement + "/ProductLine/DeleteBook",
    getCartDetails: BaseUrls.accountManagement + "/ProductLine/GetCartDetails",
    addFinalProductLines: BaseUrls.accountManagement + "/ProductLine/AddFinalProductLines",
    getProductPricings: BaseUrls.accountManagement + "/ProductLine/GetPriceTypes?productLineId="
  },

  country: {
    detectCountry: BaseUrls.accountManagement + "/Country/DetectCountry?ipAddress="
  },

  speciality: {
    getSpecialityGroups: BaseUrls.accountManagement + "/Speciality/GetSpecialityGroups"
  },

  security: {
    getIsValidPasswordToken: BaseUrls.accountManagement + "/Security/IsValidPasswordToken?token="
  },

  updatePaymentMethod: BaseUrls.salesForce + "/Accounts/UpdatePaymentMethod",

  profile: "" + BaseUrls.profile,

  linkUsers: BaseUrls.accountManagement + "/Invitation/LinkUsers"
};

exports.default = Urls;
module.exports = exports["default"];